// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cookie-alert[data-v-5c925493] {\n    z-index: 100;\n    /*2147483647;*/\n    border-radius: 0;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    margin-bottom: 0\n}\n", ""]);
// Exports
module.exports = exports;
